import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { DeploymentService } from './../../../../core/services/deployment.service';
import { Component, OnInit } from '@angular/core';
import { Deployment } from 'src/app/core/models/deployment';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { interval, Subscription } from 'rxjs';
import { OnDestroy } from '@angular/core';
import { HeaderService } from 'src/app/core/services/header.service';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';
import { Entities } from 'src/app/core/models/globals';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { UserRoleNames } from 'src/app/core/models/users';
import { NodeService } from '../../../../core/services/node.service';

@Component({
  selector: 'app-node-parent-list',
  templateUrl: './node-parent-list.component.html',
  styleUrls: ['./node-parent-list.component.scss'],
})
export class NodeParentListComponent implements OnInit, OnDestroy {
  deployments: Deployment[];
  toShow: boolean = false;
  dataEmpty: boolean;
  dataReloadSubscription: Subscription;
  nodeDeploymentListSub: Subscription;
  totalNodesOfAllDeployments: number = 0;
  isGlobalAdmin = this.authenticationService.getRole() == UserRoleNames.GlobalAdmin;
  p: number = 1;
  config = {
    itemsPerPage: 10,
    currentPage: 1
  }

  constructor(
    private depService: DeploymentService,
    private navService: NavigationService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private headerService: HeaderService,
    private syncConfig: SyncConfigService,
    private nodeService: NodeService,
    private authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    this.spinner.show()
    this.navService.subNavData(Entities.Nodes)
    this.loadNodesData()
    this.dataReloadSubscription = interval(this.syncConfig.config + 15000).subscribe((x) => {
      this.loadNodesData();
    });
  }

  ngOnDestroy(): void {
    this.dataReloadSubscription?.unsubscribe();
    this.nodeDeploymentListSub?.unsubscribe();
  }

  loadNodesData() {
    if (this.nodeDeploymentListSub) this.nodeDeploymentListSub.unsubscribe();
    this.deployments = this.depService.getProfileInfoesFromSubject()?.filter(x => x.status == 'Active');
    if (this.deployments) {
      this.manageData(this.deployments)
      // return;
    }
    this.nodeDeploymentListSub = this.depService
      .getAllDeploymentsForUser()
      .subscribe({
        next: (data) => {
          this.manageData(data)
        }, error: (err) => {
          this.spinner.hide();
          this.dataEmpty = true;
        }
      });
  }

  manageData(data) {
    if (data == null) {
      this.spinner.hide()
      this.dataEmpty = true;
    } else {
      this.deployments = <Deployment[]>JSON.parse(JSON.stringify(data));
      this.deployments = this.deployments.filter(x => x.status == 'Active')
      this.headerService.updateDeploymentList(this.deployments);
      this.nodeService.getAllNodeCount(this.authenticationService.currentUserValue.username).subscribe((data) => {
        this.totalNodesOfAllDeployments = Number(data);
      })
      if (this.deployments.length == 0) {
        this.dataEmpty = true;
        this.spinner.hide();
        return;
      } else {
        this.dataEmpty = false;
        if (!this.deployments[1] && !this.isGlobalAdmin) {
           this.toShow = true;
           this.redirectTo(this.deployments[0]);
         }
        //this.totalNodesOfAllDeployments = this.deployments.map(dep => dep.totalNodes).reduce((acc, ele) => acc + ele, 0);
        this.spinner.hide();
      }
      
    }
  }

  redirectTo(deployment: Deployment, isAll: boolean = false) {
    if (!isAll) {
      this.navService.sendChildData(deployment.name);
      this.navService.sendCloud(deployment.cloud);
      this.router.navigate([deployment.cloud, deployment.name], { relativeTo: this.route });
    } else {
      this.navService.sendChildData("All");
      this.navService.sendCloud("All");
      this.router.navigate(["User", "All", "Node"], { relativeTo: this.route });
    }
  }

  deploymentNullCheck() {
    if (this.deployments?.length > 0) {
      return this.deployments;
    }
    return [];
  }

}
